var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stars)?_c('div',{staticClass:"whs-hotel-stars"},_vm._l(((parseInt(_vm.stars / 10, 10))),function(star){return _c('div',{key:star,staticClass:"whs-hotel-star whs-icon",style:({fontSize: _vm.size + 'px'})})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }